<div class="login-wrapper">
  <div class="login-container">
    <div class="image-section">
      <div class="image-overlay">
        <div class="welcome-content">
          <h2>Welcome Back!</h2>
          <p>Sign in to access your SME Timesheet dashboard and manage your daily activities efficiently.</p>
          <div class="features">
            <div class="feature-item">
              <span class="feature-icon">📊</span>
              <span>Track Time</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">📈</span>
              <span>View Reports</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">👥</span>
              <span>Team Management</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="form-card">
        <div class="logo-section">
          <img src="assets/icons/i2e_Logo.png" alt="SME Timesheet Logo" class="logo">
          <h1 class="app-title">SME Timesheet</h1>
          <p class="subtitle">Sign in to your account</p>
        </div>

        <div class="login-form">
          <button class="sso-btn" (click)="onSSOLogin()">
          
            Sign in with SSO
          </button>

          <div class="divider">
            <span>or</span>
          </div>

          <form (ngSubmit)="onLogin()" #loginForm="ngForm">
            <div class="form-group">
              <label for="username">Username</label>
              <input type="text" id="username" [(ngModel)]="username" name="username" placeholder="Enter your username" required>
            </div>

            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" id="password" [(ngModel)]="password" name="password" placeholder="Enter your password" required>
            </div>

            <button type="submit" class="login-btn" [disabled]="!loginForm.form.valid">Sign In</button>
            <p class="error" *ngIf="errorMsg">{{ errorMsg }}</p>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>